"use client";
import { createContext, useContext } from "react";

export const defaultCurrentUserData = {
  firstName: "",
  lastName: "",
  role: "",
  department: "",
  dateOfBirth: "",
  fullName: "",
  email: "",
  avatarUrl: "",
  phone: "",
  countryName: "",
  dialCode: "",
  companyName: "",
  name: "",
  spreeId: "",
  walletBalance: "",
  programMultipleUsersPostMessage: null,
  isSsoEnabled: false,
  company: {
    id: "",
    name: "",
  },
  workspacesByDomainExists: false,
  contactProviders: [],
  contactFilters: {},
  profile: {
    autoTopUpPaymentMethod: null,
    contactsShareName: false,
    contactsSharePhoneNo: false,
    contactsShareAddress: false,
    autoTopUpAmount: null,
    autoTopUpMinBalance: null,
    autoTopUpNotes: null,
    autoTopUpAddFundsSeen: false,
    autoTopUpPaymentMethodId: null,
    lowFundsNotificationThreshold: null,
  },
  corporateBilled: false,
  accounts: [],
  walletCurrency: {
    id: "",
    code: "",
    name: "",
    symbol: "",
  },
  isActivePackageAdmin: false,
  teams: [],
  shouldSkipWorkspaceValidation: false,
};

export const defaultUserConfig = {
  id: "",
  archivedCatalogsCount: "",
  liveEshopStoreCount: "",
  marketingAnnouncementViewed: false,
  customizerGuideTourCompleted: false,
  automatedCatalogGuideTourViewed: false,
  automatedCatalogFooterCartGuideTourViewed: false,
  automatedCatalogLogoDragTooltipViewed: false,
};

export const USER_DATA_FIELDS = Object.keys(defaultCurrentUserData);

type UserContext = {
  loading?: boolean;
  /** @deprecated - to be removed post locker getting moved */
  isLoading?: boolean;
  currentUserData: typeof defaultCurrentUserData;
  currentUserConfig?: typeof defaultUserConfig;
  shouldSkipWorkspaceValidation: boolean;
  baseCountry: {
    iso: string;
    name: string;
    international: boolean;
  };
  ldData: {
    userKey: string;
    secureModeHash: string;
  };
  childCompany?: any;

  setCurrentUserData: (data: typeof defaultCurrentUserData) => unknown;
  refetch: () => Promise<unknown>;
  refetchUserConfigData: () => Promise<unknown>;
};

export const CurrentUserContext = createContext<UserContext>({
  loading: false,
  isLoading: false,
  currentUserData: defaultCurrentUserData,
  currentUserConfig: defaultUserConfig,
  shouldSkipWorkspaceValidation: false,
  baseCountry: {
    iso: "",
    name: "",
    international: false,
  },
  ldData: {
    userKey: "",
    secureModeHash: "",
  },
  childCompany: undefined,

  setCurrentUserData: (data) => null,
  refetch: () => null,
  userPackageData: {
    featureAccessMap: {},
  },
  refetchUserConfigData: () => null,
});

export const useCurrentUserContext = () => useContext(CurrentUserContext);
